import loadable from '@loadable/component';

export const JoinOtaLoadable = loadable(() => import('./JoinOta'), {
  fallback: null,
  ssr: false,
});
